module.exports = __webpack_public_path__ + "img/00024.13f43660.webp";